const setModalType = (modalType) => (ModalComponent) => {
  /* eslint-disable no-param-reassign */
  ModalComponent.modalType = modalType;

  return ModalComponent;
};

export default setModalType;
